import { Sport } from '#src/__generated__/globalTypes.ts';
import { WinterRound } from '#src/atoms/icons/WinterRound.tsx';

import setBackgroundImage from './assets/background/background.webp';
import setLeftBackgroundImage from './assets/background/freeze-left.webp';
import setRightBackgroundImage from './assets/background/freeze-right.webp';
import playFootballBackgroundImage from './assets/footballBackground.webp';
import playFootballFieldImage from './assets/footballField.webp';
import playNbaBackgroundImage from './assets/nbaBackground.webp';
import playNbaFieldImage from './assets/nbaField.webp';
import setLogoImage from './assets/set-logo.svg';
import commonPacksHeaderImage from './assets/stellar-header.webp';
import commonPacksLogoImage from './assets/stellar-logo.svg';
import cardRevealSwipeIconImage from './assets/stellar-series-icon.svg';
import playVoucherIcon from './assets/voucher.svg';

type SetPlaySportAssets = {
  backgroundImage: string;
  fieldImage: string;
};

const DEFAULT_SET_PLAY_SPORT_ASSETS: SetPlaySportAssets = {
  backgroundImage: playFootballBackgroundImage,
  fieldImage: playFootballFieldImage,
};

const SET_PLAY_SPORT_ASSETS: Partial<Record<Sport, SetPlaySportAssets>> = {
  [Sport.FOOTBALL]: DEFAULT_SET_PLAY_SPORT_ASSETS,
  [Sport.NBA]: {
    backgroundImage: playNbaBackgroundImage,
    fieldImage: playNbaFieldImage,
  },
};
export const background = {
  background: `
    url("${setLeftBackgroundImage}") left  top / contain no-repeat,
    url("${setRightBackgroundImage}") right  top / contain no-repeat,
    url("${setBackgroundImage}") center top / cover no-repeat
  `,
  backgroundBlendMode: 'color-dodge, color-dodge, normal',
};
export const SET_STELLAR = {
  slugPattern: /stellar/,
  cardSet: {
    activeSlug: 'stellar',
    activeEditionSlugs: ['stellar'] as const,
    supportedSlugs: ['stellar'] as const,
    baseSlug: 'stellar',
    displayName: 'STELLAR',
  },
  colors: {
    main: 'var(--c-set-stellar-main-color)',
    mainHex: '#7D41FF',
  },
  visual: {
    commonPacks: {
      headerImage: commonPacksHeaderImage,
      logoImage: commonPacksLogoImage,
    },
    cardReveal: {
      swipeIconImage: cardRevealSwipeIconImage,
    },
    brand: {
      logoImage: setLogoImage,
      SetIcon: WinterRound,
    },
    play: {
      getSportAssets: (sport: Sport) =>
        SET_PLAY_SPORT_ASSETS[sport] || DEFAULT_SET_PLAY_SPORT_ASSETS,
      voucherIcon: playVoucherIcon,
    },
  },
  background,
  endDate: new Date('2026-06-23T00:00:00Z'),
} as const;
